module.exports = __webpack_public_path__ + "static/media/ll.ecf47868.mp4";